// extracted by mini-css-extract-plugin
export var linkText = "_pc-0";